/**
 * Manifest display name translation keys (custompanel_ prefix for migration).
 * Used in manifest.ts; add these keys to the Editor 3 Babel project for translation.
 */
export const DisplayNames = {
  root: {
    elementDisplayName: 'Logo',
    actions: {
      settings: 'Settings',
    },
    customActions: {
      customizeLogo: 'Customize Logo',
    },
    data: {
      image: {
        displayName: 'Logo Image',
      },
    },
  },
} as const;

export const HELP_GFPP_ID = 'c2d2160a-9851-4bd4-96f1-e00e4ab40ba0';
export const SETTINGS_PANEL_HELP_ID = 'c0b9ce8f-e4ed-4852-a2f0-62f382559188';
export const defaultLogoUrl =
  'https://static.parastorage.com/services/santa-resources/dist/editor/addPanelData/sections/logo/logoDefault.v2.png';

export const brandsEndpoint = '/logoapi/logo-builder-server-webapp/v1/brands';
export const logoServerless = '/_serverless/brand-maker/api/v1';
export const editorLogoService = '/_api/branding/editor-logo-service';

export const LOGO_PREVIEWS = 'LOGO_PREVIEWS';

export const WIX_STATIC_BASE_URL = 'https://static.wixstatic.com/';
export const MEDIA_BASE_URL = WIX_STATIC_BASE_URL + 'media/';
export const SVG_MEDIA_BASE_URL = WIX_STATIC_BASE_URL + 'shapes/';
export const DEFAULT_LOGO_SIZE = 80;
export const BUILDER_IMAGE_TYPE = 'Builder.Image';
export const DEFAULT_ALT_TEXT = 'logo';

export const SUPPORTED_IMAGE_FORMATS_FOR_BACKGROUND_REMOVAL = [
  'jpeg',
  'jpg',
  'png',
  'webp',
];

// Error messages for media operations
export const MEDIA_IMPORT_FAILED_ERROR =
  'Failed to import file to media manager';
export const OPERATION_CANCELLED_ERROR = 'Operation was cancelled';
export const ABORT_ERROR_NAME = 'AbortError';

export const LOGOS_FOLDER_NAME = 'My Logos';
